import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { IWidgetConfigComponent } from 'src/app/models/dashboard/dashboard-widget.model';
import { SampleCollectionMetricsFiltersComponent } from './sample-collection-metrics-filters.component';
import {
    SampleCollectionMetricsFilterValues,
    SAMPLE_METRICS_FILTER_DEFAULTS,
    configToFilterValues,
    filterValuesToConfig
} from './sample-collection-metrics-widget.constants';

@Component({
    standalone: true,
    selector: 'app-sample-collection-metrics-widget-config',
    imports: [SampleCollectionMetricsFiltersComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
        <app-sample-collection-metrics-filters
            mode="config"
            [values]="filterValues"
            (filterChange)="onFilterChange($event)"
            (filterReconcile)="onFilterReconcile($event)">
        </app-sample-collection-metrics-filters>
    `
})
export class SampleCollectionMetricsWidgetConfigComponent implements OnInit, IWidgetConfigComponent {
    @Input() config: Record<string, unknown> = {};
    @Output() configChange = new EventEmitter<Record<string, unknown>>();

    filterValues: SampleCollectionMetricsFilterValues = { ...SAMPLE_METRICS_FILTER_DEFAULTS };

    ngOnInit(): void {
        this.filterValues = configToFilterValues(this.config);
    }

    onFilterChange(values: SampleCollectionMetricsFilterValues): void {
        this.filterValues = values;
        this.configChange.emit(filterValuesToConfig(values));
    }

    onFilterReconcile(values: SampleCollectionMetricsFilterValues): void {
        this.filterValues = values;
    }
}
